import { useLocation, useParams } from 'react-router-dom';

import { DocumentTitle } from '../../components/shared/DocumentTitle';
import { EntityStrategy } from '../strategy/EntityStrategy';
import { StrategyTypes } from '../../utilities/Constants';
import { useAuthContext } from '../../contexts/AuthContext';
import { useZoneContext } from '../../contexts/useZoneContext';

export const getEntityStrategyDisplay = (strategyEntityType: number) => {
    switch (strategyEntityType) {
        case StrategyTypes.PlaintiffsFirm.Value:
            return ' Plaintiffs Firm ';
        case StrategyTypes.Jurisdiction.Value:
            return ' Jurisdiction ';
        case StrategyTypes.LocalCounsel.Value:
            return ' Local Counsel ';
        default:
            return '';
    }
};

function EntityStrategyWrapper() {
    const { type } = useParams();
    const { key } = useLocation();
    const { user } = useAuthContext();
    const zoneContext = useZoneContext();

    return (
        <>
            <DocumentTitle title={`${getEntityStrategyDisplay(parseInt(type ?? '0'))}`} />
            <EntityStrategy
                type={parseInt(type || '')}
                user={user}
                refreshIdentifier={key}
                zoneContext={zoneContext}
            />
        </>
    );
}

export default EntityStrategyWrapper;
